import { MenuItem } from '@/shared/domain/MenuItem';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';
import MedicareButtons from '@/shared/infrastructure/components/heading/MedicareButtons.vue';

const { getEnrollmentAppUri } = useUrlHelper();

export const medicarePreset: Array < MenuItem > = [
  {
    label: 'nav.findMedicarePlans',
    href: '',
    description: null,
    customClass: '',
    prefixImg: '',
    subMenu: [
      {
        label: 'nav.findMedicarePlans',
        href: '',
        description: null,
        customClass: '',
        subMenuSideComponent: MedicareButtons,
        prefixImg: '',
        subMenu: [
          {
            label: 'nav.partsAB',
            href: '/medicare/original-medicare',
            description: null,
            customClass: '',
            prefixImg: '',
            subMenu: []
          },
          {
            label: 'nav.partC',
            href: '/medicare/medicare-advantage-part-c',
            description: null,
            customClass: '',
            prefixImg: '',
            subMenu: []
          },
          {
            label: 'nav.supplementalPlans',
            href: '/medicare/supplemental-plans',
            description: null,
            customClass: '',
            prefixImg: '',
            subMenu: []
          },
          {
            label: 'nav.partD',
            href: '/medicare/prescription-drugs-part-d',
            description: null,
            customClass: '',
            prefixImg: '',
            subMenu: []
          },
          {
            label: 'nav.dentalCoverage',
            href: getEnrollmentAppUri('/dental/quote-senior'),
            description: null,
            isAbsolute: true,
            customClass: '',
            prefixImg: '',
            subMenu: []
          },
          {
            label: 'nav.visionCoverage',
            href: getEnrollmentAppUri('/vision/quote-senior'),
            description: null,
            isAbsolute: true,
            customClass: '',
            prefixImg: '',
            subMenu: []
          }
        ]
      }
    ]
  },
  {
    label: 'nav.learnAboutMedicare',
    href: '',
    description: null,
    customClass: '',
    prefixImg: '',
    subMenu: [
      {
        label: 'nav.learnAboutMedicare',
        href: '',
        description: null,
        customClass: '',
        subMenuSideComponent: MedicareButtons,
        prefixImg: '',
        subMenu: [
          {
            label: 'nav.whatIsMedicare',
            href: '/medicare',
            description: null,
            customClass: '',
            prefixImg: '',
            subMenu: []
          },
          {
            label: 'nav.medicareEligibility',
            href: '/medicare/eligibility',
            description: null,
            customClass: '',
            prefixImg: '',
            subMenu: []
          },
          {
            label: 'nav.seniorHealthInsurancePlans',
            href: '/medicare/senior-health-insurance',
            description: null,
            customClass: '',
            prefixImg: '',
            subMenu: []
          },
          {
            label: 'nav.medicareConsentForm',
            href: getEnrollmentAppUri('/medicare/consent'),
            description: null,
            isAbsolute: true,
            isBlank: true,
            customClass: '',
            prefixImg: '',
            subMenu: []
          }
        ]
      }
    ]
  }
];
